module.exports = __webpack_public_path__ + "img/kumapeko1.f01d1fb5.png";